var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.accessToken)?_c('div',{class:_vm.isFullscreen ? 'fullChat-box' : 'chat-box'},[_c('iframe',{ref:"iframeRef",staticStyle:{"width":"100%","height":"100%"},attrs:{"src":`${_vm.env}/#/chat/${_vm.accessToken}`,"frameborder":"0","allow":"microphone"},on:{"load":_vm.handleIframeLoad}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }